import ListoryStore from '@/store';

export default class FavoriteHelper {
    public static isFavorite(store: ListoryStore, id: number): boolean {
        return store && store.poiFavorites && store.poiFavorites.includes(id);
    }

    public static addToFavorites(store: ListoryStore, id: number) {
        // check if there is already an entry
        if (store.poiFavorites.includes(id)) return;

        // add the entry
        store.poiFavorites.push(id);
    }

    public static removeFromFavorites(store: ListoryStore, id: number) {
        // remove all entries with this id in case there is more than one
        while (store.poiFavorites.includes(id)) {
            const index = store.poiFavorites.indexOf(id);
            store.poiFavorites.splice(index, 1);
        }
    }

    public static AppendFavoritFilterIfNone(store: ListoryStore) {
        store.mapChangeSourceRequest = true;
        store.mapShowFavorites = true;
    }

    public static RemoveFavoritFilterIfAny(store: ListoryStore) {
        if (store.mapShowFavorites) {
            store.mapChangeSourceRequest = true;
            store.mapShowFavorites = false;
        }
    }
}
